import { Breadcrumb as AntBreadcrumb } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

/**
 * Settings Breadcrumb
 * Shows: Settings / [Current Page]
 * For org-scoped pages: Settings / [Page] (org context is in URL)
 */
export function SettingsBreadcrumb() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const getPageTitle = () => {
    if (pathname.startsWith('/settings/profile')) return t('settings.profile');
    if (pathname.startsWith('/settings/country-configs'))
      return t('settings.countryConfigs');
    if (pathname.startsWith('/settings/document-types'))
      return t('settings.documentTypes');
    if (pathname.includes('/system')) return t('settings.tabs.system');
    if (pathname.includes('/display')) return t('settings.tabs.display');
    if (pathname.includes('/notifications'))
      return t('settings.tabs.notifications');
    if (pathname.includes('/integrations'))
      return t('settings.tabs.integrations');
    if (pathname.includes('/default-data'))
      return t('settings.tabs.defaultData');
    if (pathname.includes('/event-types')) return t('settings.tabs.eventTypes');
    if (pathname.includes('/service-types'))
      return t('settings.tabs.serviceTypes');
    return t('settings.title');
  };

  const breadcrumbItems = [
    {
      title: <Link to="/settings">{t('navigation.settings')}</Link>,
    },
    {
      title: getPageTitle(),
    },
  ];

  return <AntBreadcrumb items={breadcrumbItems} className="mb-4" />;
}
